import React from "react";

import { CHALLENGE } from "App/Routes";
import fairprice_avatar from "images/custom/placeholders/fairprice-avatar.png";
import Link from "components/shared/Link/Link";
import Claim from "components/Project/Activity/Claim";

/* Custom: fixed fairprice avatar */
class CustomClaim extends Claim {
  render() {
    let userName = this.props.userName;
    let challengeTitle = this.props.challengeTitle;
    let profileLink = this.getProfileLink();

    return (
      <div>
        <Link to={profileLink} className="pure-g bottompadding-5">
          <div className="pure-u-3-24 pure-u-md-1-24">
            <img
              className="challengeicon"
              alt={userName}
              src={fairprice_avatar}
            />
            {this.props.userRankStatusImage && (
              <div id="rankStatus" className="photo-icon-wrap xs-icon-wrap">
                <img
                  className="rank-status"
                  src={this.props.userRankStatusImage}
                  alt={this.props.userRankStatus}
                />
              </div>
            )}
          </div>
          <div className="pure-u-1-24" />
          <div className="pure-u-17-24 pure-u-md-19-24">
            <strong>{userName}</strong>
            <div className="smalltext">{this.props.createdAtFormatted}</div>
          </div>
          <div className="pure-u-3-24">
            <div className="textright topmargin-5">
              <strong>
                {this.props.points !== 0 &&
                  "+ " + this.props.points.abbreviateNumber()}
              </strong>
            </div>
          </div>
        </Link>

        <Link
          to={CHALLENGE.format(this.props.challengeId)}
          className="pure-g bottompadding-5"
        >
          <div className="pure-u-3-24 pure-u-md-1-24">
            <div
              className={
                "challengeicon icon " +
                (this.props.isConfirmationChallenge
                  ? "confirmation"
                  : this.props.challengeType)
              }
            />
          </div>
          <div className="pure-u-1-24" />
          <div className="pure-u-19-24 pure-u-md-21-24">
            <div className="topmargin-5">
              {this.renderCompletionText(challengeTitle)}
            </div>
          </div>
          <div className="pure-u-1-24 textright">
            <span className="right-caret alignmiddle topmargin-5 rightmargin-5" />
          </div>
        </Link>
      </div>
    );
  }
}

export default CustomClaim;
